import { Button, Checkbox, DialogActions, DialogContent, DialogTitle, Stack, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { TAdicionarImposto } from ".";
import { useCallback, useState } from "react";
import { formatarPorcentagem } from "../../../helpers/masks";

export default function DialogContentAdicionarImposto({
  value,
  handleSalvar

}: DialogContentAdicionarImpostoProps) {

  const [imposto, setImposto] = useState<TAdicionarImposto[]>(value);

  const handleChangeChecked = (index: number) => {
    setImposto(prev => {
      const novoValores = [...prev]
      novoValores[index] = {
        ...novoValores[index],
        valor: '0,00',
        aplica: !novoValores[index].aplica
      }
      return novoValores
    })
  }

  const handleChangeInclusoPreco = (index: number) => {
    setImposto(prev => {
      const novoValores = [...prev]
      novoValores[index] = {
        ...novoValores[index],
        incluso_preco: !novoValores[index].incluso_preco
      }
      return novoValores
    })
  }

  const handleChangeDireitoCredito = (index: number) => {
    setImposto(prev => {
      const novoValores = [...prev]
      novoValores[index] = {
        ...novoValores[index],
        direito_credito: !novoValores[index].direito_credito
      }
      return novoValores
    })
  }

  const handleChangeValor = useCallback((index: number, valor: string) => {
    const valorFormatado = formatarPorcentagem(valor);

    setImposto(prev => {
      const novoValores = [...prev]
      novoValores[index] = {
        ...novoValores[index],
        valor: valorFormatado,
      }
      return novoValores
    })
  }, [])

  return (
    <>
      <DialogTitle>Adicionar Impostos</DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell><b>Impostos</b></TableCell>
                <TableCell><b>Alíquota (%)  </b></TableCell>
                <TableCell><b>É incluso no preço?</b></TableCell>
                <TableCell><b>Direito a crédito?</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {imposto.map((row, index) => (
                <TableRow
                  key={row.nome}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Checkbox
                        checked={row.aplica}
                        onChange={() => handleChangeChecked(index)}
                        slotProps={{
                          input: { 'aria-label': 'controlled'}
                        }}
                        sx={{ padding: 0 }}
                      />
                      <Typography variant="body2">
                        {`${index + 1} - ${row.nome}`}
                      </Typography>
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <TextField
                        size="small"
                        label="Alíquota"
                        fullWidth
                        type="text"
                        value={row.aplica ? row.valor : ""}
                        disabled={!row.aplica}
                         slotProps={{
                          htmlInput: {
                            min: 0,
                            step: 0.01,
                            max: 100,
                          }
                        }}
                        onChange={(e) => handleChangeValor(index, e.target.value)}
                      />
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Switch
                        checked={row.incluso_preco ?? true}
                        onChange={() => handleChangeInclusoPreco(index)}
                        disabled={!row.aplica}
                        color="success"
                      />
                      <Typography variant="body2" color={!row.aplica ? "text.disabled" : "inherit"}>
                        Sim
                      </Typography>
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Switch
                        checked={row.direito_credito ?? true}
                        onChange={() => handleChangeDireitoCredito(index)}
                        disabled={!row.aplica}
                        color="success"
                      />
                      <Typography variant="body2" color={!row.aplica ? "text.disabled" : "inherit"}>
                        Sim
                      </Typography>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => handleSalvar(defValueImposto)}
        >
          Limpar
        </Button>
        <Button
          variant="contained"
          onClick={() => handleSalvar(imposto)}
        >
          Salvar
        </Button>
      </DialogActions>
    </>

  )
}

interface DialogContentAdicionarImpostoProps {
  value: TAdicionarImposto[];
  handleSalvar: (novosValores: TAdicionarImposto[]) => void;
}

export const defValueImposto: TAdicionarImposto[] = [
  {
    aplica: false,
    valor: '0,00',
    nome: "IPI",
    incluso_preco: true,
    direito_credito: true,
  },
  {
    aplica: false,
    valor: '0,00',
    nome: "ISS",
    incluso_preco: true,
    direito_credito: true,
  },
  {
    aplica: false,
    valor: '0,00',
    nome: "ICMS",
    incluso_preco: true,
    direito_credito: true,
  },
  {
    aplica: false,
    valor: '0,00',
    nome: "ICMS ST",
    incluso_preco: true,
    direito_credito: true,
  },
  {
    aplica: false,
    valor: '0,00',
    nome: "ICMS DIFERENCIAL",
    incluso_preco: true,
    direito_credito: true,
  },
  {
    aplica: false,
    valor: '0,00',
    nome: "PIS",
    incluso_preco: true,
    direito_credito: true,
  },
  {
    aplica: false,
    valor: '0,00',
    nome: "COFINS",
    incluso_preco: true,
    direito_credito: true,
  },
  {
    aplica: false,
    valor: '0,00',
    nome: "IBS",
    incluso_preco: true,
    direito_credito: true,
  },
  {
    aplica: false,
    valor: '0,00',
    nome: "CBS",
    incluso_preco: true,
    direito_credito: true,
  },
]
